import styles from './Footer.module.sass'
import LogoWordmark_SVG from "@/components/svg/Global/LogoWordmark_SVG"
import FooterBackgroundLeft_SVG, {FooterBackgroundRight_SVG} from "@/components/svg/Footer/FooterBackground_SVG"
import Image from "next/image"
import FooterBag_SVG from "@/components/svg/Footer/FooterBag_SVG"
import MenuLink from "@/components/Footer/MenuLink"
import Button from "@/components/Button/Button"
import Arrow_SVG from "@/components/svg/Global/Arrow_SVG"
import {useGameContext} from "@/context/GameContext"
import Link from 'next/link'
import cn from 'classnames'

const Footer = () => {

	const {isContactPopupOpen, setIsContactPopupOpen, gameTimelineRef} = useGameContext()

	return (
			<div className={styles.footer}>
				<div className={styles.footer__container}>
					{/*Background*/}
					<div className={styles.background}>
						<FooterBackgroundLeft_SVG className={styles.background_left_svg}/>
						<div className={styles.center}/>
						<FooterBackgroundRight_SVG className={styles.background_right_svg}/>
					</div>

					<FooterBag_SVG className={styles.bag_svg}/>

					{/*Title*/}
					<LogoWordmark_SVG className={styles.title_svg}/>

					<div className={styles.content}>
						<div className={styles.upper}>
							{/*	Menu*/}
							<div className={styles.menu}>
								<MenuLink href={0} text={"SACHA'S ADVENTURE"}/>
								<MenuLink text={"L'INVENTAIRE"} onClick={() => {
									const href = Math.ceil((gameTimelineRef.current.labels['book__content_appeared'] / gameTimelineRef.current.duration()) * (gameTimelineRef.current.scrollTrigger.end))
									lenis.scrollTo(href, {lock: true})
								}}/>
								<MenuLink href={"#game"} text={"4 PILIERS"}/>
								<MenuLink href={"#contact"} text={"PRENEZ RENDEZ-VOUS"}/>
							</div>

							{/*Button*/}
							<div onClick={() => {
								setIsContactPopupOpen(!isContactPopupOpen)
							}}>
								<Button className={styles.contact}
								        height={'4rem'}
								        borderSize={'1.75px'}
								        gradientPercentage={'85%'}
								        buttonPadding={'1rem'}
								>
									<div className={styles.button_content}>
										<div className={styles.text}>Contact</div>
										<Arrow_SVG className={styles.arrow} color={'#0D422E'}/>
									</div>
								</Button>
							</div>
						</div>

						{/* Legals */}
					<div className={styles.legals}>
						<Link href={'/mentions-legales'}>Mentions légales</Link>
						<span className={styles.divider}>-</span>
						<Link href={'/politique-de-confidentialite'}>Politique de confidentialité</Link>
					</div>

						{/* Credits */}
						<div className={styles.credits}>
						<div className={styles.upper}>
								<span>Made with </span>
								<Image src="/Global/SingleHeart.png"
								       alt="Heart"
								       fill={true}
								       sizes={'4rem'}
								       className={styles.heart_image}/>
							</div>
							<span><span className={styles.desktop}>-</span> Webdesign by <a className={'custom_pointer'} href={"https://gax.design/"}
							                                                                target={"_blank"}>GAX - Creative Studio</a><br/> & Developement by <a className={'custom_pointer'}
									href={"https://ziben.fr/"}
									target={"_blank"}>Ziben</a></span>
						</div>
					</div>

					<div className={styles.awwwards}>
							<Image src={"/images/EnterAnimation/cartridge_sotd.png"}
							       alt={"Gameboy cartridge for Awwwards Site Of The Day"}
							       className={styles.awwwards__image}
							       loading={"eager"}
							       width={256}
							       height={256}
							/>
					</div>
				</div>
			</div>
	)
}
export default Footer
